module.exports = __webpack_public_path__ + "img/q80_3.1da0ab50.png";